module.exports = __webpack_public_path__ + "img/horizon.05cc92a.jpg";